import API from 'js/lib/api';

import constants from 'pages/open-course/common/constants';

export default API(constants.reportsApi, {
  type: 'rest',
});
